import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { INACTIVE_STORES_PATH, VISIT_FREQUENCY_PATH } from "./reportPaths";

/**
 * The menu's name. The first tab keeps it too: it is the report this menu opened on before the
 * second tab existed.
 */
const VISIT_REPORT_TITLE = "สรุปรอบเข้าเยี่ยมร้าน";
const INACTIVE_STORES_TAB_LABEL = "ร้านค้าไม่ได้เข้านาน";

/** The tab's own path IS its value, so the highlighted tab and its URL cannot drift apart. */
type VisitReportTab = typeof VISIT_FREQUENCY_PATH | typeof INACTIVE_STORES_PATH;

interface ReportTabsProps {
  current: VisitReportTab;
}

/** Heading and tab bar shared by the two views of สรุปรอบเข้าเยี่ยมร้าน. */
export default function VisitReportTabs({ current }: Readonly<ReportTabsProps>) {
  return (
    <Stack mb={2}>
      <Typography variant="h6">{VISIT_REPORT_TITLE}</Typography>
      <Tabs value={current}>
        <Tab
          component={Link}
          to={VISIT_FREQUENCY_PATH}
          value={VISIT_FREQUENCY_PATH}
          label={VISIT_REPORT_TITLE}
        />
        <Tab
          component={Link}
          to={INACTIVE_STORES_PATH}
          value={INACTIVE_STORES_PATH}
          label={INACTIVE_STORES_TAB_LABEL}
        />
      </Tabs>
    </Stack>
  );
}
